<template>
    <Dialog v-model:visible="visible" :style="{ width: '450px' }" header="Attribute Details" :modal="true" :dismissableMask="true" @hide="$emit('hide-dialog', true)">
        <div class="surface-section">
            <ul class="list-none p-0 m-0 surface-container">
                <li class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Id</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ attribute.id }}</div>
                </li>
                <li class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Version</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ attribute.version }}</div>
                </li>
                <li v-if="attribute.icon" class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Icon</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1"><i :class="['pi', attribute.icon]" /></div>
                </li>
                <li v-if="attribute.category_id" class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Category</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ attribute.category_id }}</div>
                </li>
                <li class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Input Type</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ attribute.type }}</div>
                </li>
                <li class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Code</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ attribute.code }}</div>
                </li>
                <li v-if="attribute.label" class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Label</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ attribute.label }}</div>
                </li>
                <li v-if="attribute.placeholder" class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Placeholder</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ attribute.placeholder }}</div>
                </li>
                <li v-if="attribute.unit" class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Unit</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ attribute.unit }}</div>
                </li>
                <li v-if="attribute.options && attribute.options.length > 0" class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6">Options</div>
                    <div class="text-900 w-full">
                        <display-type :type="parseInt(attribute?.field?.type)" :placeholder="attribute.placeholder" :options="attribute.options" />
                    </div>
                </li>
                <li v-if="attribute.tag && attribute.tag.length > 0" class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Tags</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">{{ attribute.tag }}</div>
                </li>
                <li class="py-3 px-2 border-top-1 surface-border">
                    <div class="text-500 w-6 md:w-2 font-medium">Required</div>
                    <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1"><Tag :severity="attribute.required ? '' : 'danger'" :value="attribute.required ? 'True' : 'False'" rounded /></div>
                </li>
            </ul>
        </div>
    </Dialog>
</template>

<script setup>
import DisplayType from '../../../../../components/input-type/DisplayType.vue';

import { ref, defineProps } from 'vue';

const props = defineProps({
    attribute: {
        type: Object,
    },
});

const visible = ref(true);

const attribute = ref(props.attribute);
</script>

<style scoped>
li {
    display: flex;
    flex-direction: row;
}
li > div {
    display: flex;
    justify-content: left;
    align-items: center;
}
li > div:nth-child(odd) {
    width: 30% !important;
}
li > div:nth-child(even) {
    width: 70% !important;
}
</style>
